
// SEO utility functions for generating structured data
export const generateLocalBusinessSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "おかやま放課後等デイサービス",
    "description": "岡山市北区の放課後等デイサービス。発達障害のお子様への専門的な療育・支援を提供。",
    "url": siteUrl,
    "telephone": "086-012-3456",
    "faxNumber": "086-012-3457",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "○○町1-2-3",
      "addressLocality": "岡山市北区",
      "addressRegion": "岡山県",
      "postalCode": "700-0000",
      "addressCountry": "JP"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 34.6617,
      "longitude": 133.9341
    },
    "openingHours": "Mo-Sa 09:00-18:00",
    "founder": {
      "@type": "Person",
      "name": "岡山太郎"
    },
    "areaServed": {
      "@type": "City",
      "name": "岡山市"
    },
    "serviceType": "放課後等デイサービス",
    "priceRange": "$$"
  };
};

export const generateWebPageSchema = (pageTitle: string, pageDescription: string, pagePath: string) => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageTitle,
    "description": pageDescription,
    "url": `${siteUrl}${pagePath}`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "おかやま放課後等デイサービス",
      "url": siteUrl
    },
    "about": {
      "@type": "Organization",
      "name": "おかやま放課後等デイサービス"
    },
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "おかやま放課後等デイサービス"
    }
  };
};

export const generateFAQSchema = (faqs: Array<{question: string, answer: string}>) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

export const generateOrganizationSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "おかやま放課後等デイサービス",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "description": "岡山市北区の放課後等デイサービス。発達障害のお子様への専門的な療育・支援を提供。",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "○○町1-2-3",
      "addressLocality": "岡山市北区",
      "addressRegion": "岡山県",
      "postalCode": "700-0000",
      "addressCountry": "JP"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "086-012-3456",
      "contactType": "customer service",
      "areaServed": "JP",
      "availableLanguage": "Japanese"
    },
    "founder": {
      "@type": "Person",
      "name": "岡山太郎"
    },
    "foundingDate": "2000",
    "numberOfEmployees": 5
  };
};

export const generateBreadcrumbSchema = (breadcrumbs: Array<{name: string, url: string}>) => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `${siteUrl}${item.url}`
    }))
  };
};
